<template>
	<div class="col-project">
    <figure v-if="trProject.thumbCover">
			<img class="toLoad" 
				v-if="trProject.thumbCover.extension != 'gif'" 
				v-lazy="trProject.thumbCover.thumb" 
        :src="trProject.thumbCover.src"
				:srcset="trProject.thumbCover.srcset"
				sizes="100vw, (min-width: 768px) 50vw, (min-width: 1040px) 50vw"
				:key="trProject.uid" 
        :alt="trProject.thumbCover.alt"
				@load="displayImage($event)"/>
        <img class="toLoad" 
          v-else 
          :src="trProject.thumbCover.url" 
          :alt="trProject.thumbCover.alt"
          @load="displayImage($event)"
         />
    </figure>
			<div class="infos">
        <template v-if="trProject">
          <h1>{{ trProject.title }}</h1>
          <div class="subtitle" v-html="trProject.additionalInformations"></div>
        </template>
        <template v-else>
           <h1>{{ trProject.title }}</h1>
            <div class="subtitle" v-html="trProject.additionalInformations"></div>
         </template>
			</div>
	</div>
</template>
<script>

export default {
	props: ['project','currentLang'],
  data(){
    return{
      trProject : this.project[this.currentLang] ? this.project[this.currentLang] : this.project,
    }
  },
  watch:{
    currentLang(currentLang){
      this.trProject = this.project[currentLang] ? this.project[currentLang] : this.project;
    }
  },
	methods:{
		displayImage(e){
			let el = e.target;
			setTimeout(
				function(){ el.classList = 'loaded';
			}, 500);
		}
	},
}
</script>

<style lang="scss" scoped>
    .item {
      figure{
        height:0;
        overflow:hidden;
        padding-bottom: 65%;
        position: relative;
        img{ 
          width: 100%;
          position:absolute;
          height:100%;
          object-fit:cover;
          top:0;
          left:0;
          right:0;
          bottom:0;
          @include transition(transform .5s ease);
          @include transform(scale(1));
        }
      }

      div:not(.inactive):hover{
        img{
          @include transform(scale(1.01));
        }
      }
     
      h1{
        font-size:1.25rem;
        line-height: 1.44rem;
        font-family:'surtSemiBold', Helevetica, Arial, sans-serif;
        color:rgba(20, 20, 20, 1);
      }
      .subtitle{
        font-size:0.933rem;
        line-height:1.12rem;
        max-width:400px;
        margin-top: 2px;
        color: rgba(32, 34, 38, 1);
      }
      .infos{
        opacity:1;
        height: 75px;
        margin-top:15px;
      }
    }

    .item--50{
      figure{
         padding-bottom: calc(65% + 89px);
      }
    }

    .whiteMode .item img{
		@include box-shadow(0, 0, 20px, #000);
    }
</style>